/**
 * Plan Welcome — EdgenModal 外壳尺寸（传给 `EdgenModalCreateAble.call`）。
 *
 * 设计稿分工：
 * - 内容布局：Figma H5 `45185:412591`（全屏背景 + 标题 + 底部 CTA）
 * - PC 外壳：Figma `45506:12455`（仅宽高、圆角、关闭按钮位置；不含 Goal Card 内容）
 *
 * | 端   | 宽              | 高        | 圆角 | 关闭                         |
 * |------|-----------------|-----------|------|------------------------------|
 * | H5   | 100%            | 100dvh    | 0    | 内容层左上返回               |
 * | PC   | 400px           | 515px     | 16px | 内容层右上 X（showClose: false） |
 *
 * `showClose: false`：深色背景上自绘白色 close，不用 OspModal 默认关闭钮。
 */

export const ONBOARDING_PLAN_WELCOME_MODAL_PC_WIDTH_PX = 400;
export const ONBOARDING_PLAN_WELCOME_MODAL_PC_HEIGHT_PX = 515;
export const ONBOARDING_PLAN_WELCOME_MODAL_PC_RADIUS_PX = 16;

/** 静态 props；className 勿运行时拼接，避免 Uno 扫描不到任意值类名 */
export const ONBOARDING_PLAN_WELCOME_MODAL_PROPS = {
  className:
    "[--modal-radius:0px] md:[--modal-radius:16px] [--modal-height:100dvh] md:[--modal-height:515px] md:[--modal-width:400px] [--modal-width:100%]",
  contentStyle: {
    borderRadius: "var(--modal-radius)",
    width: "var(--modal-width)",
    height: "var(--modal-height)",
    overflow: "hidden" as const,
    padding: 0,
  },
  styles: {
    body: {
      height: "100%",
    },
  },
  containerStyle: {
    height: "100%",
    width: "100%",
    maxHeight: "100%",
  },
  titleStyle: {
    minHeight: 0,
  },
  showClose: false,
  maskClosable: false,
  destroyOnClose: true,
} as const;
